<script lang="tsx">

import {defineComponent} from 'vue';
import Icon from "@/components/common/icons/Icon.vue"
import Copy from "@/components/common/typography/Copy.vue";

export default defineComponent({
  name: 'Toast',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  components: {
    Copy,
    Icon
  },
  setup(props, context) {
    return () =>
      <div class={"toast"}>
        <div class="toast-content">
          <Icon name="Check"/>
          <Copy class="toast-text" type="Black">{props.text}</Copy>
        </div>
      </div>
  }
});
</script>


<style lang="scss" scoped>
@import "src/css/common/index";

@include important {
  .toast {
    position: fixed;
    bottom: $spacing-5;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;

    &-content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: $spacing-1 $spacing-2;

      background: $color-brand-2;
      border-radius: 4px;

      color: $color-surface;

      .icon {
        font-size: 24px;
      }

      > * + * {
        margin-left: $spacing-1;
      }
    }

    @media (max-width: $breakpoint-XS) {
      @include content-container;
      bottom: $spacing-4;

      &-content {
        width: 100%;
      }
    }

  }
}
</style>
